var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projectLayoutsee"},[_c('div',{staticClass:"content"},[(_vm.type == 'level')?_c('level',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.type == 'vertical')?_c('vertical',{attrs:{"id":_vm.id}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }